import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

export default function PricingPlans() {
  const { t } = useTranslation();

  const freePlanFeatures = [
    t('pricing.free.f1'), t('pricing.free.f2'), t('pricing.free.f3'),
    t('pricing.free.f4'), t('pricing.free.f5'), t('pricing.free.f6'),
  ];

  return (
    <section className="py-20 lg:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-5xl lg:text-6xl font-black text-gray-900 mb-6">
            {t('pricing.title')}
          </h2>
          <p className="text-xl lg:text-2xl text-gray-600 font-semibold max-w-3xl mx-auto mb-10">
            {t('pricing.subtitle')}
          </p>
        </div>

        <div className="max-w-2xl mx-auto">
          {/* 完全免费方案 */}
          <div className="relative rounded-3xl p-10 lg:p-12 transition-all hover:scale-105 bg-gradient-to-br from-primary to-primary-600 text-white shadow-2xl">
            <div className="absolute -top-5 left-1/2 transform -translate-x-1/2">
              <span className="px-6 py-2 bg-accent text-white text-sm font-black rounded-full shadow-lg whitespace-nowrap">
                {t('pricing.popular')}
              </span>
            </div>
            <div className="mb-8 text-center">
              <h3 className="text-3xl font-black mb-3 text-white">{t('pricing.free.name')}</h3>
              <p className="text-lg font-semibold mb-6 text-white/90">{t('pricing.free.desc')}</p>
              <div className="flex items-baseline justify-center gap-2">
                <span className="text-7xl font-black text-white">$0</span>
                <span className="text-2xl font-bold text-white/80">/forever</span>
              </div>
              <p className="text-lg font-bold text-white/90 mt-3">完全免费 · 无需登录 · 无限使用</p>
            </div>
            <ul className="space-y-4 mb-8">
              {freePlanFeatures.map((feature, index) => (
                <li key={index} className="flex items-start gap-3">
                  <i className="ri-checkbox-circle-fill text-2xl flex-shrink-0 mt-0.5 text-white"></i>
                  <span className="text-lg font-semibold text-white">{feature}</span>
                </li>
              ))}
            </ul>
            <Link
              to="/generator"
              className="block w-full px-8 py-5 rounded-xl font-black text-lg text-center transition-all cursor-pointer whitespace-nowrap bg-white text-primary hover:bg-gray-100 hover:shadow-xl"
            >
              {t('pricing.free.cta')}
            </Link>
          </div>
        </div>

        <div className="mt-16 text-center">
          <div className="inline-flex items-center gap-3 px-8 py-4 bg-gray-50 rounded-full border-2 border-gray-200">
            <i className="ri-shield-check-line text-3xl text-primary"></i>
            <span className="text-base font-bold text-gray-900">永久免费 · 无隐藏费用 · 无使用限制</span>
          </div>
        </div>
      </div>
    </section>
  );
}